<app-auth-modal-content
    [nextURL]="nextURL"
    [overrideStudentNext]="overrideStudentNext"
    [activeModal]="activeModal"
    [description]="description"
>
</app-auth-modal-content>
